/** Core Data Model */
export interface Submission {
  id: number;
  lastUpdatedAt: string;
  payload: SubmissionPayload;
  feedbackProvided: boolean;
  quipUserId: number;
  surveyId: number;
  enrollmentId: number;
  finalised: boolean;
}

export interface SubmissionPayload {
  sections: SubmissionPayloadSection[];
  openQuestionAnswers: OpenQuestionAnswer;
  // customFieldsAnswers: unknown;
  // customFieldsFreeTextAnswers: unknown;
  generalComment: string;
}

export interface SubmissionPayloadSection {
  version: number;
  questions: SubmissionSectionQuestion;
  context: SubmissionSectionContext;
  discardSubmission?: boolean,
}

export interface SubmissionSectionQuestion {
  [key: string]: {
    answers: MainSubmissionAnswerPayload[];
  };
}

interface OneOfAnswer {
  type: 'OneOf';
  answer: string; // uuid
}

interface MultiChoiceAnswer {
  type: 'MultipleChoice';
  choices: {
    [uuid: string]: boolean;
  };
}

interface StringAnswer {
  type: 'ArbitraryString';
  answer: string;
}

export type MainSubmissionAnswerPayload = OneOfAnswer | MultiChoiceAnswer | StringAnswer

export interface SubmissionSectionContext {
  [key: string]: ContextAnswer | ContextAnswerDetailed[];
}

interface ContextAnswer {
  answer: string;
}

interface ContextAnswerDetailed {
  answer: string;
  detailQuestionAnswer: string;
}

interface OpenQuestionAnswer {
  [key: string]: ContextAnswerDetailed[];
}

/** Redux Submission State */

export interface SubmissionState {
  payload: SubmissionPayload;
}

/** Redux constants */

export const SET_MAIN_QUESTION_ANSWER = 'SET_MAIN_QUESTION_ANSWER';
export const SET_CONTEXT_QUESTION_ANSWER = 'SET_CONTEXT_QUESTION_ANSWER';
export const RESET_SUBMISSION_STATE = 'RESET_SUBMISSION_STATE';
export const SET_DISCARD_SUBMISSION_SECTION = 'SET_DISCARD_SUBMISSION_SECTION';
export const RECALL_SUBMISSION_STATE = 'RECALL_SUBMISSION_STATE';
export const DELETE_SECTION_SUBMISSIONS = 'DELETE_SECTION_SUBMISSIONS';
export const CREATE_EMPTY_SUBMISSION_SECTIONS = 'CREATE_EMPTY_SUBMISSION_SECTIONS';

/** Action Types */

interface SetMainQuestionAction {
  type: typeof SET_MAIN_QUESTION_ANSWER;
  sectionIndex: number;
  questionUuid: string;
  sampleIndex: number;
  answerPayload: MainSubmissionAnswerPayload;
}

interface SetContextQuestionAnswerAction {
  type: typeof SET_CONTEXT_QUESTION_ANSWER;
  sectionIndex: number;
  questionUuid: string;
  payload: SubmissionSectionContext['uuid'];
}

interface ResetSubmissionStateAction {
  type: typeof RESET_SUBMISSION_STATE;
}

interface DiscardSubmissionSectionAction {
  type: typeof SET_DISCARD_SUBMISSION_SECTION;
  payload: {
    sectionId: number;
    discard: boolean;
  }
}

interface RecallSubmissionStateAction {
  type: typeof RECALL_SUBMISSION_STATE;
  payload: SubmissionPayload;
}

interface DeleteSectionSubmissionsAction {
  type: typeof DELETE_SECTION_SUBMISSIONS;
  payload: {
    sectionId: number;
  }
}

interface CreateEmptySubmissionSectionsAction {
  type: typeof CREATE_EMPTY_SUBMISSION_SECTIONS;
  payload: {
    numSections: number;
  }
}

export type SubmissionActionType = SetMainQuestionAction
  |SetContextQuestionAnswerAction
  |ResetSubmissionStateAction
  |DiscardSubmissionSectionAction
  |RecallSubmissionStateAction
  |DeleteSectionSubmissionsAction
  |CreateEmptySubmissionSectionsAction;
